/**
 * usePaginacao
 * Substitui o mixin TableHelper.js.
 * Lida com pesquisa local, ordenação e paginação.
 */
export function usePaginacao() {
  function normalize(str) {
    return str
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  function filtrarLocalmente(tableData, searchQuery, propsToSearch) {
    if (!searchQuery) return tableData;
    const query = normalize(searchQuery);
    return tableData.filter((row) =>
      propsToSearch.some((key) => {
        const val = row[key];
        return val && normalize(val.toString()).includes(query);
      })
    );
  }

  function ordenarLocalmente(dados, sortProp, sortOrder) {
    if (!sortProp || !sortOrder) return dados;
    return [...dados].sort((a, b) => {
      let aVal = a[sortProp] ?? "";
      let bVal = b[sortProp] ?? "";
      if (typeof aVal === "string" && typeof bVal === "string") {
        return sortOrder === "ascending"
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }
      return sortOrder === "ascending" ? aVal - bVal : bVal - aVal;
    });
  }

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  return { normalize, filtrarLocalmente, ordenarLocalmente, debounce };
}
